var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56263 12.0968C8.5379 12.2634 8.38199 12.3802 8.21477 12.3562C7.68751 12.2798 8.14446 11.391 8.08594 11.2417C7.76716 10.4276 7.33303 9.68592 6.79447 9.0195C3.32732 9.01304 0.552755 6.54056 0.114849 3.04643C3.7456 2.66507 7.45031 4.64115 7.58774 8.59143C6.00914 6.58742 4.14829 5.57922 3.19945 5.05311C2.98165 4.93243 2.79727 5.26447 3.01514 5.38581C5.25672 6.62839 7.19283 8.13212 8.30592 10.4584C9.11301 7.8249 10.8252 5.79178 12.8988 3.9305C13.1201 3.73171 12.8177 3.39465 12.5963 3.59281C11.6333 4.45765 9.73685 6.12842 8.43495 8.8802C7.54173 4.24715 11.3244 0.959604 15.6496 0.434873C16.0739 4.61431 13.5043 8.23435 9.47222 9.16714C9.02331 10.0861 8.71594 11.065 8.56261 12.0971L8.56263 12.0968Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.b79a97160a58e7ffe6bc43d5ca31adc9.svg";
export { ForwardRef as ReactComponent };